import { render, staticRenderFns } from "./PurchaseManage.vue?vue&type=template&id=a92016b2&"
import script from "./PurchaseManage.vue?vue&type=script&lang=js&"
export * from "./PurchaseManage.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports